// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "管理学",
      "tec": "吕开颜",
      "week": "6-14,16-18周",
      "add": "教学楼D座320经管"
    },
    0,
    0,
    0,
    {
      "sub": "形势与政策",
      "tec": "王姝",
      "week": "6-9周",
      "add": "教学楼C座311教务"
    }
  ],
  "2": [
    {
      "sub": "专业导论",
      "tec": "王庆喜",
      "week": "9,11-14,16-18周",
      "add": "教学楼D座226经管"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "刘娜",
        "week": "6-17周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "26经管2-1",
        "tec": "曹艳春",
        "week": "6-17周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "26经管2-2",
        "tec": "徐亮",
        "week": "6-17周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "26经管1-1",
        "tec": "王国志",
        "week": "6-17周",
        "add": "实训楼E座414管理"
      }
    ],
    {
      "sub": "军事理论",
      "tec": "田凤权",
      "week": "6-14周",
      "add": "教学楼D座326文法"
    },
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[07-08节]）"
    },
    0
  ],
  "3": [
    {
      "sub": "人工智能与计算思维",
      "tec": "刘晓慧",
      "week": "7,9,11,13,17周",
      "add": "教学楼D座320经管"
    },
    {
      "sub": "微积分（一）",
      "tec": "陆歆怡",
      "week": "6-17周",
      "add": "教学楼D座326文法"
    },
    0,
    {
      "sub": "健康教育",
      "tec": "谢雨彤",
      "week": "6-17周",
      "add": "教学楼C座308教务"
    },
    0
  ],
  "4": [
    {
      "sub": "管理学",
      "tec": "吕开颜",
      "week": "6-14,16-18周",
      "add": "教学楼D座320经管"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "曹艳春",
        "week": "6-17周",
        "add": "教学楼A座122信息"
      },
      {
        "sub": "26经管2-2",
        "tec": "刘娜",
        "week": "6-17周",
        "add": "教学楼D座226经管"
      },
      {
        "sub": "26经管2-1",
        "tec": "王国志",
        "week": "6-17周",
        "add": "教学楼D座320经管"
      },
      {
        "sub": "26经管1-2",
        "tec": "徐亮",
        "week": "6-17周",
        "add": "教学楼D座326文法"
      }
    ],
    {
      "sub": "就业创业指导",
      "tec": "王倩",
      "week": "6-10周",
      "add": "教学楼D座326文法"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "微积分（一）",
      "tec": "陆歆怡",
      "week": "6-17周",
      "add": "教学楼D座326文法"
    },
    [
      {
        "sub": "人工智能与计算思维",
        "tec": "刘晓慧",
        "week": "6,8,10,12,14,16周",
        "add": "实训楼C座318"
      },
      {
        "sub": "人工智能与计算思维",
        "tec": "刘晓慧",
        "week": "7,9,11,13,17周",
        "add": "教学楼D座320经管"
      }
    ],
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
